export default __webpack_public_path__ + "static/media/wave-5.7742bb69.png";